import { ArrowRight, MessageCircle, Phone } from "lucide-react";

export default function InlineCTABanner({
    heading = "¿Listo para tu cotización?",
    subheading = "Respuesta en menos de 24h. Ingenieros propios. Garantía formal por escrito.",
    onCtaClick,
    ctaLabel = "Cotizar en línea",
    whatsappUrl,
    tel,
    variant = "dark",
    testId = "inline-cta-banner",
}) {
    const dark = variant === "dark";
    return (
        <section
            data-testid={testId}
            className={`py-12 sm:py-16 ${dark ? "bg-eclipse-primary text-white" : "bg-eclipse-light text-eclipse-primary"}`}
        >
            <div className="container-eclipse flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="text-center md:text-left">
                    <h3 className={`font-display font-black text-2xl sm:text-3xl tracking-tight leading-tight ${dark ? "text-white" : "text-eclipse-primary"}`}>
                        {heading}
                    </h3>
                    <p className={`mt-2 text-sm sm:text-base ${dark ? "text-white/75" : "text-eclipse-muted"}`}>
                        {subheading}
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0 w-full md:w-auto">
                    {whatsappUrl && (
                        <a
                            href={whatsappUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`${testId}-whatsapp`}
                            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-sm font-display font-bold text-xs uppercase tracking-wider bg-[#25D366] hover:bg-[#1ebd5b] text-white transition-colors"
                        >
                            <MessageCircle className="w-4 h-4" />
                            WhatsApp
                        </a>
                    )}
                    {tel && (
                        <a
                            href={`tel:${tel}`}
                            data-testid={`${testId}-tel`}
                            className={`hidden sm:inline-flex items-center justify-center gap-2 px-5 py-3 rounded-sm font-display font-bold text-xs uppercase tracking-wider border-2 transition-colors ${dark ? "border-white text-white hover:bg-white hover:text-eclipse-primary" : "border-eclipse-primary text-eclipse-primary hover:bg-eclipse-primary hover:text-white"}`}
                        >
                            <Phone className="w-4 h-4" />
                            Llamar
                        </a>
                    )}
                    {onCtaClick && (
                        <button
                            onClick={onCtaClick}
                            data-testid={`${testId}-action`}
                            className="btn-eclipse-cta inline-flex items-center justify-center gap-2 px-5 py-3 rounded-sm text-xs uppercase tracking-wider"
                        >
                            {ctaLabel}
                            <ArrowRight className="w-4 h-4" />
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
}
